/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/24
 * Time: 16:09
 * Desc: 添加网点弹窗
 */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import { IPSService } from '@/services/ipsServices';
import ExportFile from '@/views/components/exportFile';
import { Functions } from '@/library/utils/functions';

@DialogFactory
@Component
export default class AdjustmentHistory extends IPSDialog {
  width = '1000px';
  title = '账户余额调整履历';
  confirm = false;
  loadingState = false;
  keyword: '';
  keywords = '';
  data = [];
  totalCount = 0;
  page = 1;
  pageSize = 10;
  key = 0
  get exportParams() {
    return {
      exportType: 'vGuiderBalanceChange',
      params: {},
    };
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getData();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getData();
  }

  getData() {
    IPSService.vGuiderChangeBalanceList({ postParams: { keywords: this.keywords, page: this.page, pageSize: this.pageSize } }).then((res) => {
      this.totalCount = res.count;
      if (res && res.list && res.list.length > 0) {
        res.list.forEach((item) => {
          item.buyerName = Functions.emptyVaribleHandler(item.buyerName);
          item.siteName = Functions.emptyVaribleHandler(item.siteName);
          item.siteCode = Functions.emptyVaribleHandler(item.siteCode);
          item.buyerPhone = Functions.emptyVaribleHandler(item.buyerPhone);
          item.buyerCardNumber = Functions.emptyVaribleHandler(item.buyerCardNumber);
          item.applyEmpName = Functions.emptyVaribleHandler(item.applyEmpName);
          item.reason = Functions.emptyVaribleHandler(item.reason);
          item.finishTime = Functions.timeFormat(item.finishTime);
        });
      }
      this.data = res.list;
      this.key = Math.random()
    });
  }

  created() {
    this.keywords = this.keyword;
    this.getData();
  }

  onSearch() {
    this.page = 1;
    this.getData();
  }

  moneyRevert(money) {
    return (
      `￥${Number(money)
        .toString()
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
    );
  }

  getType(item) {
    if (item.type === 1) {
      return `+${this.moneyRevert(item.balanceChange)}`;
    } else {
      return `-${this.moneyRevert(item.balanceChange)}`;
    }
  }

  renderContent(h) {
    return (
      <div class="r-px-20">
        <div class="flex-inline items-center border-bottom-white hei-28 width-100 line-height-56 border-box">
          <div class="wid-195 flex-inline items-center hei-16 relative-position fl">
            <el-input v-model={this.keywords} placeholder="姓名/手机号/身份证号/网点编号/网点名称"></el-input>
            <i class="wid-15 hei-15 line-height-30 font-size-18 text-grey-15 absolute right-0 cursor-pointer iconfont iconsousuo" onClick={() => this.onSearch()}></i>
          </div>
        </div>
        <el-table key={this.key} height="350" v-loading={this.loadingState} style="width: 100%" data={this.data} ref="multipleTable">
          <el-table-column type="index" label="#" width="80" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column prop="buyerName" label="姓名" width="110px" align="left" show-overflow-tooltip {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span v-encrypt={{ data: scope.row.buyerName, type: 'name' }}> {scope.row.buyerName}  </span>
                  );
                },
              },
            }} />
          <el-table-column prop="buyerPhone" width="180" label="手机号" show-overflow-tooltip {...{
            scopedSlots: {
              default: (scope) => {
                return (
                  <span v-encrypt={{ data: scope.row.buyerPhone, type: 'phone' }}> {scope.row.buyerPhone}  </span>
                );
              },
            },
          }} />
          <el-table-column prop="buyerCardNumber" label="身份证号" width="200px" align="left" show-overflow-tooltip {...{
            scopedSlots: {
              default: (scope) => {
                return (
                  <span v-encrypt={{ data: scope.row.buyerCardNumber, type: 'idcard' }}> {scope.row.buyerCardNumber}  </span>
                );
              },
            },
          }} />
          <el-table-column
            prop="siteInfo"
            label="所属网点"
            min-width="160px"
            align="left"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span>
                      [{scope.row.siteCode}]{scope.row.siteName}
                    </span>
                  );
                },
              },
            }}></el-table-column>
          <el-table-column
            prop="balanceBefore"
            label="调整前余额"
            width="120px"
            align="right"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{this.moneyRevert(scope.row.balanceBefore)}</span>;
                },
              },
            }}></el-table-column>
          <el-table-column
            prop="balanceChange"
            label="调整余额"
            min-width="120px"
            align="right"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{this.getType(scope.row)}</span>;
                },
              },
            }}></el-table-column>
          <el-table-column
            prop="balanceAfter"
            label="调整后余额"
            min-width="120px"
            align="right"
            show-overflow-tooltip
            {...{
              scopedSlots: {
                default: (scope) => {
                  return <span>{this.moneyRevert(scope.row.balanceAfter)}</span>;
                },
              },
            }}></el-table-column>
          <el-table-column prop="reason" label="调整原因" min-width="120px" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applyEmpName" label="操作人" min-width="120px" align="left" show-overflow-tooltip></el-table-column>
          <el-table-column prop="finishTime" label="操作时间" min-width="160px" align="left" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="hei-21 r-mt-10 r-py-0 r-pr-18 r-pl-16 border-bottom-white">
          <ExportFile class="fl line-height-32" export-text="导出" params={this.exportParams} http-type="post" is-button={false} service-url="adminExport"></ExportFile>
          <div class="fr ">
            <el-pagination
              on-size-change={this.onSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[10, 15, 20, 30]}
              page-size={this.pageSize}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.totalCount}></el-pagination>
          </div>
        </div>
      </div>
    );
  }
}
